// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"345":"bb286051","940":"bb286051","1221":"bb286051","4854":"bb286051","8559":"bb286051"}[chunkId] + ".chunk.css";
};